import { render } from "./PartGroup.vue?vue&type=template&id=2a1395f4"
import script from "./PartGroup.vue?vue&type=script&lang=js"
export * from "./PartGroup.vue?vue&type=script&lang=js"
script.render = render

export default script